import React, { useCallback } from "react";
import { Box, Radio } from "@material-ui/core";
import clsx from "clsx";
import {
  useCheckoutState,
  useCheckoutStateSelector as useSelector,
} from "@capone/checkout";
import { ExperienceLanguageGuide } from "redmond";
import { AVAILABILITY_LANG_GUIDE_LABEL_MAPPING } from "halifax";

import { ActivityAdditionalDetailsSelectors } from "../../../../../checkout";
import { Event, TEvent } from "../../../state/events";
import { ActivityMachineContext } from "../../../state/types";

import styles from "./styles.module.scss";
import { LangGuideValidation } from "../../../../../checkout/states/AdditionalDetails";

export const SelectLang = () => {
  const [, send] = useCheckoutState<TEvent, ActivityMachineContext>();

  const productOptionLangGuides = useSelector(
    ActivityAdditionalDetailsSelectors.getBookableLangGuides
  );
  const selectedLangGuide = useSelector(
    ActivityAdditionalDetailsSelectors.getSelectedLangGuide
  );

  const validationErrors = useSelector(
    ActivityAdditionalDetailsSelectors.getAdditionalDetailsErrors
  );

  const clearValidationErrors = useCallback(() => {
    send({ type: Event.CLEAR_ADDITIONAL_DETAILS_ERROR });
  }, []);

  const handleRowSelection = (data: ExperienceLanguageGuide) => {
    send({
      type: Event.SET_SELECTED_LANG_GUIDE,
      data,
    });
    clearValidationErrors();
  };

  const hasLangGuideSelectionError = validationErrors.includes(
    LangGuideValidation.LangSelection
  );

  return (
    <div className={styles["section-container"]}>
      <div
        className={clsx(styles["section-title"], {
          [styles.error]: hasLangGuideSelectionError,
        })}
      >
        Select language
      </div>
      <div
        className={clsx(styles["section-subtitle"], {
          [styles.error]: hasLangGuideSelectionError,
        })}
      >
        This provider offers this activity in multiple languages
      </div>
      <div className={styles["radio-selection-container"]}>
        {productOptionLangGuides.map((option) => (
          <div key={option.language} className={styles["radio-row-container"]}>
            <Radio
              className={styles.radio}
              checked={option.language === selectedLangGuide?.language}
              onChange={() => handleRowSelection(option)}
            />
            <Box
              className={clsx(styles["row-label"], {
                [styles.selected]:
                  option.language === selectedLangGuide?.language,
              })}
              onClick={() => handleRowSelection(option)}
            >
              {`${option.languageDisplayName} - ${
                AVAILABILITY_LANG_GUIDE_LABEL_MAPPING[option.guideType]
              }`}
            </Box>
          </div>
        ))}
      </div>
      {hasLangGuideSelectionError && (
        <div className={clsx(styles["error-caption"], [styles.error])}>
          You must make a selection to continue.
        </div>
      )}
    </div>
  );
};
